export default "__VITE_ASSET__CJ2k8GUj__"